import React from 'react';
import './language-header.styles.less';
import { Link } from 'gatsby';
import { FLAG_DE, FLAG_EN, FLAG_UA, LOGO, LOGO_WITH_TEXT_BLACK } from 'assets/icons/icons';
import { useIsDesktop } from 'logic/hooks/use-is-tablet';
import { Button, Layout, Menu } from 'antd';
import { Text } from '../../../../../components/text/Text';
import { StyledDropdown } from 'src/pages-all/master-page/components/master-header/master-header';
import { MenuOutlined } from '@ant-design/icons';
import { Profile } from '../premium-header/premium-header';
import RightMenu from '../../../../master-page/components/right-menu/right-menu';
import styled from 'styled-components';
import { useI18nConfig } from 'logic/translations/use-i18n-config';
import { KnownLocale } from 'logic/translations/i18n-config';
import { AppRoute } from '../../../../../app/app.route.const';
import { navigationSlice } from '../../../../../logic/store/navigation/navigation.slice';
import { useDispatch } from 'react-redux';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { useLocalizedI18nGlobal } from '../../../../../logic/translations/use-localized-i18n-global';
import { NEW } from '../../../../../assets/images/images';

const { Header } = Layout;

const LanguageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LanguageHeader: React.FC = () => {
  useLocalizedI18nGlobal();
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const [i18nConfig, { setLocale }] = useI18nConfig();

  const changeLocale = (locale: KnownLocale): void => {
    if (locale !== i18nConfig.locale) {
      setLocale(locale);
    }
  };

  const LanguageSelection = () => (
    <div>
      <Menu
        selectedKeys={[i18nConfig.locale]}
        mode={isDesktop ? 'horizontal' : 'vertical'}
        style={{
          width: isDesktop ? '' : '230px',
        }}
      >
        <Menu.Item key={'de'}>
          <LanguageContainer
            onClick={() => {
              changeLocale('de');
            }}
          >
            <img src={FLAG_DE} height={12} alt={'german flag'} loading="lazy" />
            <Text style={{ display: 'block', marginLeft: '4px' }}>{'Deutsch'}</Text>
          </LanguageContainer>
        </Menu.Item>
        <Menu.Item key={'en'}>
          <LanguageContainer
            onClick={() => {
              changeLocale('en');
            }}
          >
            <img src={FLAG_EN} height={12} alt={'uk flag'} loading="lazy" />
            <Text style={{ display: 'block', marginLeft: '4px' }}>{'English'}</Text>
          </LanguageContainer>
        </Menu.Item>
        <Menu.Item key={'ua'}>
          <LanguageContainer
            onClick={() => {
              changeLocale('ua');
            }}
          >
            <img src={FLAG_UA} height={12} alt={'ukrainian flag'} loading="lazy" />
            <Text style={{ display: 'block', marginLeft: '4px' }}>{'Українська'}</Text>
          </LanguageContainer>
        </Menu.Item>
        <Menu.Item key={'news'}>
          <LanguageContainer
            onClick={() => {
              dispatch(navigationSlice.actions.navigateTo({ path: AppRoute.News }));
            }}
          >
            <img src={NEW} height={28} alt={'news icon'} loading="lazy" />
            <Text style={{ display: 'block', marginLeft: '4px' }}>
              {translate(translationKeys.homepage.refugeeHeader.news)}
            </Text>
          </LanguageContainer>
        </Menu.Item>
      </Menu>
    </div>
  );

  return (
    <Header className="master-header noselect">
      <div className="header-container">
        <div className="left-menu-content">
          {!isDesktop && (
            <Link to="/">
              <img className="logo" src={LOGO} alt="logo" loading="lazy" />
            </Link>
          )}
          {isDesktop && (
            <Link to="/">
              <img
                className="logo-with-text"
                src={LOGO_WITH_TEXT_BLACK}
                alt="logo"
                loading="lazy"
              />
            </Link>
          )}
          {isDesktop && <LanguageSelection />}
          {!isDesktop && (
            <Profile>
              <div className="right-menu-content">
                <RightMenu />
              </div>
            </Profile>
          )}
        </div>
        {isDesktop && (
          <Profile>
            <div className="right-menu-content">
              <RightMenu />
            </div>
          </Profile>
        )}
        {!isDesktop && (
          <StyledDropdown overlay={<LanguageSelection />} trigger={['hover', 'click']}>
            <Button>
              <MenuOutlined />
            </Button>
          </StyledDropdown>
        )}
      </div>
    </Header>
  );
};
